import knowledge from './knowledge.json'
import { request } from '@/utils/request'

export const apiMap = {
  getPaperInfo: '/v1/paper/info' // 根据试卷id获取试卷内容
}

export const getBrushQuestionTextVersion = (params) => {
  return request.get('/bookapi/v1/brush-question/text-version', params)
  //   return Promise.resolve({
  //     status: 200,
  //     code: 0,
  //     message: 'success',
  //     response_time: 1669953597,
  //     data: {
  //       label: '修改年级',
  //       options: [
  //         {
  //           id: '1',
  //           name: '小学',
  //           childList: {
  //             label: '',
  //             options: [
  //               {
  //                 id: '1',
  //                 name: '一年级',
  //                 childList: {
  //                   label: '当前学期',
  //                   options: [
  //                     {
  //                       id: '1',
  //                       name: '上学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: 'a5b9af13a54c4f3aab34edee15e8b4bf', name: '部编版（2016）' },
  //                           {
  //                             id: '084ccee96b1b45b8ab0987b9102291c5',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     },
  //                     {
  //                       id: '2',
  //                       name: '下学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: '805a7ee2a2444bbebe92874f9b17f6cb', name: '部编版（2016）' },
  //                           {
  //                             id: 'a3d7caa15dd8499296f5a266892315cb',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     }
  //                   ]
  //                 }
  //               },
  //               {
  //                 id: '2',
  //                 name: '二年级',
  //                 childList: {
  //                   label: '当前学期',
  //                   options: [
  //                     {
  //                       id: '1',
  //                       name: '上学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: 'f14f0ce1db0a478395d319851708519e', name: '部编版（2016）' },
  //                           {
  //                             id: '2ad59b78f0d840a7b809b27617c35c40',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     },
  //                     {
  //                       id: '2',
  //                       name: '下学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: 'd58cbc2296ce4e608aa4af636374702c', name: '部编版（2016）' },
  //                           {
  //                             id: '41acef57d9654057914b8fcfa70b5e83',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     }
  //                   ]
  //                 }
  //               },
  //               {
  //                 id: '3',
  //                 name: '三年级',
  //                 childList: {
  //                   label: '当前学期',
  //                   options: [
  //                     {
  //                       id: '1',
  //                       name: '上学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: 'c93b38541cf94a88b78c932e2f43f66b', name: '部编版（2016）' },
  //                           {
  //                             id: '1729dd36d072461189bf255ca7097888',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     },
  //                     {
  //                       id: '2',
  //                       name: '下学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: '42092ebb69d2415fb164e4a07b06b9ae', name: '部编版（2016）' },
  //                           {
  //                             id: 'b43f1f6184a447118ba7fbe1c0e1e0fd',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     }
  //                   ]
  //                 }
  //               },
  //               {
  //                 id: '4',
  //                 name: '四年级',
  //                 childList: {
  //                   label: '当前学期',
  //                   options: [
  //                     {
  //                       id: '1',
  //                       name: '上学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: '4665785fea54488baca10c05f80e553f', name: '部编版（2016）' },
  //                           {
  //                             id: 'f6b7ada6143b4e74b0419985e9da721a',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     },
  //                     {
  //                       id: '2',
  //                       name: '下学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: 'f18ce05cffbe4d7a9c289c5c86885eed', name: '部编版（2016）' },
  //                           {
  //                             id: 'fb238a2fc0c540ccbab72c2b6685c32a',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     }
  //                   ]
  //                 }
  //               },
  //               {
  //                 id: '5',
  //                 name: '五年级',
  //                 childList: {
  //                   label: '当前学期',
  //                   options: [
  //                     {
  //                       id: '1',
  //                       name: '上学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: '705f3504d3704fea90da6b57f2a0baa9', name: '部编版（2016）' },
  //                           {
  //                             id: '01ae690c90da44d4a88938ba85031793',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     },
  //                     {
  //                       id: '2',
  //                       name: '下学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: '81eedadb684d4c4e9ab84d9369aae567', name: '部编版（2016）' },
  //                           {
  //                             id: '814f004222554ae797130d835077a721',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     }
  //                   ]
  //                 }
  //               },
  //               {
  //                 id: '6',
  //                 name: '六年级',
  //                 childList: {
  //                   label: '当前学期',
  //                   options: [
  //                     {
  //                       id: '1',
  //                       name: '上学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: '056ad5ae8c3d45ec9e09676af480c4f8', name: '部编版（2016）' },
  //                           {
  //                             id: '54981276618c48c8a4a3eeee3051549b',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     },
  //                     {
  //                       id: '2',
  //                       name: '下学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: 'ca240313b5ad46479227e06dc7b7e30b', name: '部编版（2016）' },
  //                           {
  //                             id: 'e248b4c05cc342d1a0ed55733ca2698a',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     }
  //                   ]
  //                 }
  //               }
  //             ]
  //           }
  //         },
  //         {
  //           id: '2',
  //           name: '初中',
  //           childList: {
  //             label: '',
  //             options: [
  //               {
  //                 id: '7',
  //                 name: '七年级',
  //                 childList: {
  //                   label: '当前学期',
  //                   options: [
  //                     {
  //                       id: '1',
  //                       name: '上学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: '62a0e432f20a4b229f8cd8270005ce1f', name: '部编版（2016）' },
  //                           {
  //                             id: '47e1f3f2142f489bbb05222b51747a7f',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     },
  //                     {
  //                       id: '2',
  //                       name: '下学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: 'f47ea327eca74d82bc6b5290eb06029a', name: '部编版（2016）' },
  //                           {
  //                             id: '32bcc1421296468c86e6c084e4e0fb4f',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     }
  //                   ]
  //                 }
  //               },
  //               {
  //                 id: '8',
  //                 name: '八年级',
  //                 childList: {
  //                   label: '当前学期',
  //                   options: [
  //                     {
  //                       id: '1',
  //                       name: '上学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: '380b3db6c81645fda5878758a6e7b565', name: '部编版（2016）' },
  //                           {
  //                             id: 'e463921b60124ff896cc5e9a043b54fe',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     },
  //                     {
  //                       id: '2',
  //                       name: '下学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: 'a22ba1ccf662493390e19a5229ddcda5', name: '部编版（2016）' },
  //                           {
  //                             id: '4bf0e0a658f1460195ad35455f295b49',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     }
  //                   ]
  //                 }
  //               },
  //               {
  //                 id: '9',
  //                 name: '九年级',
  //                 childList: {
  //                   label: '当前学期',
  //                   options: [
  //                     {
  //                       id: '1',
  //                       name: '上学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: '96f57e8c98c645dc8e3fa45cf0427968', name: '部编版（2016）' },
  //                           {
  //                             id: '40faa0ce168d4091835cf9d3868213fe',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     },
  //                     {
  //                       id: '2',
  //                       name: '下学期',
  //                       childList: {
  //                         label: '选择教材',
  //                         options: [
  //                           { id: '9953ca1dc28f4c8fb41f4893a9d731e2', name: '部编版（2016）' },
  //                           {
  //                             id: '49fa4002789149f5b1931df55a35482b',
  //                             name: '部编版（2016）（五四制）'
  //                           }
  //                         ]
  //                       }
  //                     }
  //                   ]
  //                 }
  //               }
  //             ]
  //           }
  //         }
  //       ]
  //     }
  //   })
}
console.log(knowledge)
export const getBrushQuestionKnowledge = (params) => {
  return request.get('/bookapi/v1/brush-question/knowledge', params)
}

// 获取题目列表
export const getQuestionList = (data) => {
  return request.get('/bookapi/v1/brush-question/list', data)
}
// 保存作答结果
export const saveAnswer = (data) => {
  return request.post('/bookapi/v1/brush-question/save', data)
}

export const test = (p) => request.get('/v1/question/cancel-wrong-question', p)
